
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import dan from "../../assets/dan.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarDan({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar dán fordító</title>
                <meta name='description' content="Ingyenes magyar dán fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar dán fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-dan-fordito" />
            </Helmet>
            <h1>Magyar dán fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A magyar és dán nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={dan} alt="dán zászló"></img>
                </div>


                <p>Íme néhány fő különbség a dán és a magyar között:</p>

                <h3>Nyelvcsalád</h3>

                <ul>
                    <li><b>Dán</b>: A dán az indoeurópai nyelvcsalád észak-germán ágához tartozik, valamint más skandináv nyelveket, például a svédet és a norvégot.</li>
                    <li><b>Magyar</b>: a magyar finnugor nyelv, az uráli nyelvcsalád része, amely magában foglalja a finn, észt és számos más nyelvet, amelyet főleg Északkelet-Európában beszélnek.</li>
                </ul>


                <h3>Nyelvtan</h3>

                <ul>

                <li><b>Dán</b>: A dán nyelvtan viszonylag egyszerű a magyarhoz képest. Nyelvtani eseteinek nagy részét elvesztette, és inkább a szórendre és az elöljárószavakra támaszkodik a nyelvtani kapcsolatok jelzésére.</li>
                <li><b>Magyar</b>: A magyarnak összetettebb agglutinatív nyelvtana van. A szótövekhez fűződő toldalékrendszert használja, hogy kifejezze az olyan nyelvtani jellemzőket, mint az idő, a mód, a szám és a birtoklás. Gazdag főnévi esetrendszerrel is rendelkezik a nyelvtani szerepek jelzésére.</li>
                </ul>
                <h3>Szókincs</h3>

                <ul>
                    <li><b>Dán</b>: A dán szókincs elsősorban az óskandináv nyelvből származik, és hasonlóságokat mutat más skandináv nyelvekkel. Más germán nyelvekből és latinból is kölcsönzött szavakat. A dán nyelvnek sok rokonsága van az angollal.</li>
                    <li><b>Magyar</b>: A magyar szókincs egyedi, és nincs szoros rokonságban más európai nyelvekkel. Néhány szót kölcsönzött a szomszédos nyelvekből, például a németből, a törökből és a szláv nyelvekből. A magyar nyelv uráli gyökereiből megőrzött elemeket.</li>
                </ul>

                <h3>Kiejtés</h3>
                <ul>

                    <li><b>Dán</b>: A dán kiejtése kihívást jelenthet változatos magánhangzói, lágy mássalhangzói, valamint az írott és a beszélt formák közötti különbségek miatt. A kiejtés regionálisan is változhat.</li>
                    <li><b>Magyar</b>: A magyar nyelvnek egyszerűbb hangrendszere van, következetes kiejtési szabályokkal. Ha megtanulja az egyes betűk és betűkombinációk kiejtését, könnyebbé válik a magyar szavak olvasása és kiejtése.</li>

                </ul>
                <h3>Mondatszerkezet</h3>
                <ul>
                    <li><b>Dán</b>: A dán a germán nyelvekben általánosan elterjedt alany-ige-tárgy (SVO) szórendet követ.</li>
                    <li><b>Magyar</b>: A magyar nyelvnek van Subject-Object-Ige (SOV) szórendje, ami eltér a legtöbb európai nyelv tipikus szórendjétől. Az ige általában a mondat végére kerül.</li>
                </ul>

                <div className="sectionbottom">
                    <Link to="/dan-magyar-fordito">Dán magyar fordító</Link>
                    <img src={dan} alt="dán zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarDan;